
<template>
	<c-dialog ref="dialog" title="平台选品市场" width="1000" @resolve="resolve" button-name="确认添加" cancel-button-name="关闭">
		<m-search ref="search" @search="searchHandle">
			<m-search-item label="搜索关键字">
				<c-input name="keyword"></c-input>
			</m-search-item>
			<m-search-item label="产品类目">
			  <c-select name="product_type_id" options="PRODUCT_CLASSIFY"></c-select>
			</m-search-item>
		</m-search>
		<c-table ref="table" height="550">
			<c-table-column
				type="selector"
				:multiple="!!multiple"
				:selected="row => row.data.checked"
			></c-table-column>
			
			<c-table-column
				label="商品ID"
				width="70"
				name="product_id"
			></c-table-column>
			
			<c-table-column
				label="商品信息"
				width="500"
			>
				<template #default="{data}">
					<product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
					<product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
				</template>
			</c-table-column>
			
			<c-table-column
				label="品牌"
				width="80"
				name="product_brand"
			></c-table-column>
			
			<c-table-column
				label="实时供货价"
				width="80"
				name="sale_price"
			></c-table-column>
			
			<c-table-column
				label="销量"
				width="80"
				name="sale_count"
			></c-table-column>
			
		</c-table>
	</c-dialog>
</template>

<script>
	import productInfo from '@/components/public/product_info.vue'
	export default {
		props: {
			multiple: Boolean
		},
		
		components: {
			productInfo
		},
		
		methods: {
			open() {
				this.$refs.dialog.open();
				this.$refs.search.clear();
				this.$refs.table.load({
					url: '/platform/product/list',
					data: {
					}
				});
			},
			close(){
				this.$refs.dialog.close();
			},
			
			searchHandle(data) {
				this.$refs.table.load({
					url: '/platform/product/list',
					data: Object.assign(data, {
						state: [1]
					})
				});
			},
			
			resolve(stop) {
				stop();
				var data = this.$refs.table.getRow('selected');
				if (!data.length) {
					this.$message({
						message: '请选择商品'
					});
					return;
				}
				this.$emit('resolve', Array.from(data, item => item.data));
			}
		}
	}
</script>